"use client";
import React, { useEffect } from "react";
import styled from "styled-components";
import { gsap } from "gsap";
import { SplitText } from "gsap/SplitText";
import ServiceList from "@/components/service/ServiceList";
import InnerBanner from "@/components/InnerBanner";
import ServiceOverview from "@/components/service/ServiceOverview";
import ServiceFeature from "@/components/service/Features";
import ServiceForm from "@/components/service/ServiceForm";
import { ParallaxX, ParallaxXR, splitLeft } from "../animation/TextAnimation";
import { FadeUp } from "../animations/TextAnimations";

const AllServicesDetails = ({ data }) => {
  const banner = data?.page_data?.[0]?.banner;
  const overview = data?.page_data?.[0]?.overview;
  const features = data?.page_data?.[0]?.features;

  ParallaxX(data);
  ParallaxXR(data);
  splitLeft(data);
  FadeUp(data);

  return (
    <StyledComponent>
      <InnerBanner
        data={data?.page_data?.[0]}
        title={banner?.title}
        subtitle={banner?.subtitle}
        text={banner?.desc}
        img={banner?.img}
      />
      <ServiceOverview data={overview} />
      <ServiceFeature data={features} />
      <ServiceForm />
    </StyledComponent>
  );
};

const StyledComponent = styled.section``;

export default AllServicesDetails;
